module.exports = __webpack_public_path__ + "static/media/ripley-comm-thread-graphic.c67fac53.png";